import enUS from './en-US'

export default {
  en: { // this is the default namespace; this can also be a "namespace" like 'US' as in 'en-US'
    ualcore: enUS,
  },
  'en-US': { // this is the default namespace; this can also be a "namespace" like 'US' as in 'en-US'
    ualcore: enUS,
  },
  es: {
    ualcore: {
      logout: 'Cerra sesión',
      instructionsToContinue: 'para continuar por favor hace una eleción',
    },
  },
  'pt-BR': {
    ualcore: {
      logout: 'Sair',
      instructionsToContinue: 'para continuar por favor hace una eleción',
    },
  },
}
